// handlers/LoginSuccessHandler.jsx
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from '../context/authProvider';

const AuthSuccessHandler = () => {
  // state.auth is the authReducer slice; state.auth.auth is the login payload
  // ({ user, organization, settings, token, ... }) set by the LOGIN saga / boot hydration.
  const reduxAuth = useSelector((state) => state.auth?.auth);
  const { setAuth } = useAuth();

  useEffect(() => {
    if (reduxAuth) {
      setAuth(reduxAuth);
    }
  }, [reduxAuth, setAuth]);

  return null;
};

export default AuthSuccessHandler;
